import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import { DialogRef } from "@fundamental-ngx/core/dialog";
import {Const, ResourceType} from '../../../../core/helpers/Const';
import { NotificationsService } from '../../../../service/services/misc/notifications/notifications.service';
import {UntypedFormBuilder, UntypedFormControl, Validators} from "@angular/forms";
import {
    BaseCreateDialogComponent
} from "../../../../core/components/abstract/base-create-dialog/base-create-dialog.component";
import {DialogService} from "../../../../service/services/misc/dialog/dialog.service";
import {SwaService} from "../../../../service/services/misc/swa/swa.service";
import {UisService} from "../../../../service/services/misc/uis/uis.service";
import {CustomValidators} from "../../../../core/helpers/CustomValidators";
import {Utils} from "../../../../core/helpers/Utils";

@Component({
    selector: 'app-move-resource-dialog',
    templateUrl: './move-resource-dialog.component.html',
    styleUrls: ['./move-resource-dialog.component.scss'],
    standalone: false
})
export class MoveResourceDialogComponent extends BaseCreateDialogComponent implements OnInit {
    title: string;
    infoText: string;
    Const = Const;
    currentPath: string;
    destinationPathPlaceholder: string;
    destinationNamePlaceholder: string;

    constructor(
        public override dialogRef: DialogRef,
        public override dialogService: DialogService,
        public override notificationsService: NotificationsService,
        protected override fb: UntypedFormBuilder,
        protected override cdRef: ChangeDetectorRef,
        protected override _swaService: SwaService,
        protected override _uisService: UisService,
    ) {
        super(dialogRef, dialogService, notificationsService, fb, cdRef, _swaService, _uisService);
        this.form.addControl('path', new UntypedFormControl('', [Validators.required, CustomValidators.ValidatePath]));
    }

    override ngOnInit(): void {
        this.resource = this.dialogRef.data.resource;
        this.resourceDisplayName = this.resource?.displayName;
        this.currentPath = this.resource?.path;
        this.title = `Move ${this.resource?.typeDisplayName || this.resource?.type}`;
        this.infoText = this.getMoveInfoText();
        this.destinationPathPlaceholder = this.getDestinationPathPlaceholder();
        this.destinationNamePlaceholder = this.getDestinationNamePlaceholder();
        this.validate();
    }

    async onMoveResource() {
        const moveDetails = {
            resource: this.resource,
            targetResourceName: this.form.get('name').value,
            targetResourcePath: this.form.get('path').value,
        };
        this.dialogRef.close(moveDetails);
    }

    validate() {
        return !this.loading &&
            !!this.form.get('path').value &&
            !!this.form.get('name').value &&
            (Utils.getValidationState(this.form.get('path')) !== 'error') &&
            (Utils.getValidationState(this.form.get('name'))  !== 'error');
    }

    getMoveInfoText() {
        const currentType = this.resource?.type;
        switch (currentType) {
        case ResourceType.FOLDER:
            return $localize`:YMSG|Info Text for move folder dialog@@moveResource.dialog.infoText:Enter the details of the folder where you want to move the selected folder and its contents.`;
        case ResourceType.RESOURCE_GROUP:
            return $localize`:YMSG|Info Text for move resource-group dialog@@moveResource.dialog.infoText:Enter the details of the folder where you want to move the selected resource group and its contents.`;
        default:
            return $localize`:YMSG|Info Text for move resource dialog@@moveResource.dialog.infoText:Enter the details of the folder or resource where you want to move the selected resource.`;
        }
    }

    getDestinationPathPlaceholder() {
        const currentType = this.resource?.type;
        switch (currentType) {
        case ResourceType.FOLDER:
            return $localize`:XMSG|Placeholder for path to target folder dialog@@moveResource.dialog.placeholder:Enter path of target folder`;
        case ResourceType.RESOURCE_GROUP:
            return $localize`:XMSG|Placeholder for path to target folder dialog@@moveResource.dialog.placeholder:Enter path of target folder`;
        default:
            return $localize`:XMSG|Placeholder for path to target resource dialog@@moveResource.dialog.placeholder:Enter path of target folder or resource group`;
        }
    }

    getDestinationNamePlaceholder() {
        const currentType = this.resource?.type;
        switch (currentType) {
        case ResourceType.FOLDER:
            return $localize`:XMSG|Placeholder for name of target folder dialog@@moveResource.dialog.placeholder:Enter technical name of target folder`;
        case ResourceType.RESOURCE_GROUP:
            return $localize`:XMSG|Placeholder for name of target folder dialog@@moveResource.dialog.placeholder:Enter technical name of target folder`;
        default:
            return $localize`:XMSG|Placeholder for name of target resource dialog@@moveResource.dialog.placeholder:Enter technical name of target folder or resource group`;
        }
    }
}
